import React, { useEffect } from 'react';
import classnames from 'classnames';

import { PAYMENT_WIDGET_ID_ACQ } from '@/shared/lib/paymentManager';

import styles from './PaymentWidgetModal.module.css';

interface PaymentWidgetProps {
    start: () => void;
}

export const PaymentWidgetModal = ({ start }: PaymentWidgetProps) => {
    useEffect(() => {
        start();
    }, [start]);

    useEffect(() => {
        document.body.classList.add(styles.noScroll);

        return () => {
            document.body.classList.remove(styles.noScroll);
        };
    }, []);

    return (
        <div className={classnames(styles.overlay, styles.visible)}>
            <div id={PAYMENT_WIDGET_ID_ACQ} className={styles.root} />
        </div>
    );
};
